// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pop-up-loading[data-v-02b155bc]{display:flex;align-items:center;justify-content:center;z-index:1100}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
